import { Typography } from '@mui/material';
import styled from 'styled-components';

const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.backdrop.light};
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const KeyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.palette.backdrop.light};
  padding: ${({ theme }) => theme.spacing(2, 3)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  outline: 2px solid ${({ theme }) => theme.palette.backdrop.dark};
`;

const TooltipLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 180px;
`;

const Title = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.backdrop.contrastText};
    font-size: 16px;
  }
`;

const InfoContainer = styled.div`
  margin-top: -${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

interface SortContainerProps {
  $isMd: boolean;
}

const SortContainer = styled.div<SortContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const SortText = styled.span`
  white-space: nowrap;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export { Circle, List, KeyContainer, LegendContainer, TooltipLabel, TooltipContainer,
  Title, InfoContainer, SortContainer, SortText };
